import { render } from "./InlineSocialContent.vue?vue&type=template&id=3bc7a56c"
import script from "./InlineSocialContent.vue?vue&type=script&lang=js"
export * from "./InlineSocialContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/InlineSocialContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bc7a56c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bc7a56c', __exports__)) {
    api.reload('3bc7a56c', __exports__)
  }
  
  module.hot.accept("./InlineSocialContent.vue?vue&type=template&id=3bc7a56c", () => {
    api.rerender('3bc7a56c', render)
  })

}


export default __exports__